/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Home_Advice_Title1Inputs */

const vi_sitesettings_home_advice_title1 = /** @type {(inputs: Sitesettings_Home_Advice_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề ô tư vấn`)
};

/**

* @param {Sitesettings_Home_Advice_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_home_advice_title1 = /** @type {((inputs?: Sitesettings_Home_Advice_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Home_Advice_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_home_advice_title1(inputs)
});
export { sitesettings_home_advice_title1 as "siteSettings_home_advice_title" }